module.exports = __webpack_public_path__ + "static/mobile-cursor-524493fdc31509cc743a42f02b8b88e2.webm";